import { useTranslation } from 'react-i18next';
import { TextField } from './FormField';
import { toHebrewName } from '@/helpers/hebrewName';
import styles from './PersonFields.module.scss';

interface PersonFieldsProps {
  namePrefix: string;
}

const PersonFields = ({ namePrefix }: PersonFieldsProps) => {
  const { t } = useTranslation();
  const f = (suffix: string) => `${namePrefix}.${suffix}` as never;

  return (
    <div className={styles.grid}>
      <TextField name={f('firstName')} label={t('openFundRequest.fields.firstName')} transform={toHebrewName} />
      <TextField name={f('lastName')} label={t('openFundRequest.fields.lastName')} transform={toHebrewName} />
      <TextField name={f('israeliId')} label={t('openFundRequest.fields.israeliId')} />
      <TextField name={f('city')} label={t('openFundRequest.fields.city')} />
      <TextField name={f('street')} label={t('openFundRequest.fields.street')} />
      <TextField name={f('houseNumber')} label={t('openFundRequest.fields.houseNumber')} />
      <TextField name={f('email')} label={t('openFundRequest.fields.email')} type="email" />
      <TextField name={f('phone')} label={t('openFundRequest.fields.phone')} type="tel" />
    </div>
  );
};

export default PersonFields;
